import {
  Building2,
  User,
  Users,
  ScrollText,
  CreditCard,
  Lock,
  Landmark,
} from 'lucide-react';

export const FULL_ONBOARDING_STEPS = [
  { id: 'clinic-info', title: 'Clinic Info', icon: Building2 },
  { id: 'owner-info', title: 'Owner Info', icon: User },
  { id: 'practitioners', title: 'Invite Practitioners', icon: Users },
  { id: 'acknowledgement', title: 'Agreement', icon: ScrollText },
  { id: 'billing', title: 'Card Details', icon: CreditCard },
  { id: 'stripe-onboarding', title: 'Stripe Setup', icon: Landmark },
] as const;

export const PARTIAL_ONBOARDING_STEPS = [
  { id: 'set-password', title: 'Set Password', icon: Lock },
  { id: 'acknowledgement', title: 'Agreement', icon: ScrollText },
  { id: 'billing', title: 'Card Details', icon: CreditCard },
  { id: 'stripe-onboarding', title: 'Stripe Setup', icon: Landmark },
] as const;

export type FullOnboardingStepId = (typeof FULL_ONBOARDING_STEPS)[number]['id'];
export type PartialOnboardingStepId = (typeof PARTIAL_ONBOARDING_STEPS)[number]['id'];

/**
 * Returns steps to show for full onboarding. Hides practitioners step for guided archetype.
 */
export function getVisibleSteps(
  steps: ReadonlyArray<{ id: string; title: string; icon: unknown }>,
  archetype?: 'guided' | 'direct' | 'hybrid' | null
) {
  if (archetype === 'guided') {
    return steps.filter((s) => s.id !== 'practitioners');
  }
  return [...steps];
}
